<template>
  <TermsOfUseChile v-if="isChile"></TermsOfUseChile>
  <TermsOfUseDefault v-else></TermsOfUseDefault>
</template>

<script>
import { EventBus } from '@/services/eventBus';
import keys from '@/store/keys';
import store from '@/store';
import utilService from '@/services/utilService';
import TermsOfUseChile from '@/components/public/legal/termsOfUse/TermsOfUseChile';
import TermsOfUseDefault from '@/components/public/legal/termsOfUse/TermsOfUseDefault';

export default {
  name: 'TermsOfUse',
  metaInfo() {
    return {
      title: this.$i18n.t('page.title'),
      meta: [
        {
          name: 'description',
          content: this.$i18n.t('page.description'),
        },
        {
          name: 'apple-itunes-app',
          content: 'app-id=573568924',
        },
        {
          name: 'keywords',
          content: this.$i18n.t('page.keywords'),
        },
        {
          property: 'twitter:title',
          content: this.$i18n.t('meta.twitter.title'),
        },
        {
          property: 'twitter:card',
          content: 'photo',
        },
        {
          property: 'twitter:site',
          content: this.twitterHashtag,
        },
        {
          property: 'twitter:image',
          content: utilService.getSharedLogo(),
        },
        {
          property: 'twitter:url',
          content: window.location.href,
        },
        {
          property: 'og:title',
          content: this.$i18n.t('meta.og.title'),
        },
        {
          property: 'og:url',
          content: window.location.href,
        },
        {
          property: 'og:site_name',
          content: 'wesmartPark',
        },
        {
          property: 'og:type',
          content: 'website',
        },
        {
          property: 'og:description',
          content: this.$i18n.t('meta.og.description'),
        },
        {
          property: 'og:image',
          content: utilService.getSharedLogo(),
        },
        {
          property: 'og:image:secure_url',
          content: utilService.getSharedLogo(),
        },
        {
          property: 'og:image:alt',
          content: this.$i18n.t('meta.og.image'),
        },
        {
          property: 'og:image:width',
          content: '1200',
        },
        {
          property: 'og:image:height',
          content: '586',
        },
        {
          property: 'og:image:type',
          content: 'image/jpeg',
        },
      ],
    };
  },
  components: {
    [TermsOfUseChile.name]: TermsOfUseChile,
    [TermsOfUseDefault.name]: TermsOfUseDefault,
  },
  computed: {
    isChile() {
      return utilService.isChile();
    },
  },
  data() {
    return {
      langSelected: store.state.langSelected,
    };
  },
  created() {
    EventBus.$on(keys.eventOnLanguageChanged, this.changeLanguage);
  },
  destroyed() {
    EventBus.$off(keys.eventOnLanguageChanged, this.changeLanguage);
  },
  methods: {
    changeLanguage(params) {
      this.langSelected = store.state.langSelected;
    },
  },
};
</script>
